import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-product';

const list = (page = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/products`, {
		page,
		pageSize,
	});
};

export default { list };
